export default __webpack_public_path__ + "static/media/button__chat.def820f8.svg";